/**
 * The lots a bench used for its last unit, kept on the device so the worker
 * only re-types a lot number when a new box of parts is opened.
 */

const KEY = (stationId: string, itemId: string) => `atlas:work:lots:${stationId}:${itemId}`;

export type StickyLots = Record<string, string>; // component item id -> lot number

export function loadStickyLots(stationId: string, itemId: string): StickyLots {
  try {
    const raw = window.localStorage.getItem(KEY(stationId, itemId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') return {};
    const out: StickyLots = {};
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof v === 'string' && v.trim()) out[k] = v.trim();
    }
    return out;
  } catch {
    return {};
  }
}

export function saveStickyLots(stationId: string, itemId: string, lots: StickyLots): void {
  try {
    const cleaned: StickyLots = {};
    for (const [k, v] of Object.entries(lots)) if (v.trim()) cleaned[k] = v.trim();
    if (Object.keys(cleaned).length === 0) window.localStorage.removeItem(KEY(stationId, itemId));
    else window.localStorage.setItem(KEY(stationId, itemId), JSON.stringify(cleaned));
  } catch {
    /* private mode */
  }
}
